import { createContext, useContext, useEffect, useState } from "react";
import Answer from "./Answer";
import Player from "./Player";
import Score from "./Score";
import { GameContext, TestContext } from "../context/globalContext";


export default function Standard() {
    const [currentSong, setCurrentSong] = useState(null)
    const [score, setScore] = useState(null)
    const [answerContext, setAnswerContext] = useState(null)
    const [songIndex, setSongIndex] = useState(0)
    const [songsContext, setSongsContext] = useState(0)

    /* useEffect(() => {
      //console.log(`answer = ${gameContext.answerContext}`)
      console.log(`currentSong = ${gameContext.currentSong}`)
    
    }, [gameContext.currentSong]) */
    
    const player = {
        name: 'Mutuca',
        id: '1'
    }
    
    return(
        <div className="game">
            <GameContext.Provider value={{currentSong, setCurrentSong, score, setScore, answerContext, setAnswerContext, setSongIndex, songIndex, songsContext, setSongsContext}}>
                <Score player={player} gamemode={'standard'}/>
                {<Player gamemode={'standard'}/>}
                <Answer/>
            </GameContext.Provider>
        </div>
    )
}